var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { SteppedPageModule } from './stepped-page';
import { Module, State, Mutation } from 'vuex-simple';
import { AppModule } from '@/store/modules/app';
import { ManagementPageModule } from '@/store/modules/management-page';
import { ItemsModule } from '@/store/modules/items';
import { DialogModule } from '@/store/modules/dialog';
import { PartialSaveModule } from '@/store/modules/partial-save';
var RootStore = /** @class */ (function () {
    function RootStore() {
        this.loading = false;
        this.app = new AppModule();
        this.items = new ItemsModule();
        this.managementPage = new ManagementPageModule(this);
        this.dialog = new DialogModule(this);
        this.partialSave = new PartialSaveModule(this);
        this.steppedPage = new SteppedPageModule(this);
    }
    RootStore.prototype.setLoading = function (loading) {
        this.loading = loading;
    };
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], RootStore.prototype, "loading", void 0);
    __decorate([
        Module(),
        __metadata("design:type", Object)
    ], RootStore.prototype, "app", void 0);
    __decorate([
        Module(),
        __metadata("design:type", Object)
    ], RootStore.prototype, "items", void 0);
    __decorate([
        Module(),
        __metadata("design:type", Object)
    ], RootStore.prototype, "managementPage", void 0);
    __decorate([
        Module(),
        __metadata("design:type", Object)
    ], RootStore.prototype, "dialog", void 0);
    __decorate([
        Module(),
        __metadata("design:type", Object)
    ], RootStore.prototype, "partialSave", void 0);
    __decorate([
        Module(),
        __metadata("design:type", Object)
    ], RootStore.prototype, "steppedPage", void 0);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], RootStore.prototype, "setLoading", null);
    return RootStore;
}());
export { RootStore };
